import "core-js/modules/es6.function.name";
import OrgTransfer from "./OrgTransfer";
import OrgSelect from "./OrgSelect";
var components = [OrgTransfer, OrgSelect];
var install = function install(Vue) {
  components.map(function (component) {
    Vue.component(component.name, component);
  });
};
export default {
  install: install
};